import { Container, Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import ATOM_ICON from '@/assets/images/presentation/atom-icon.png';
import ATTENDANCE_ICON from '@/assets/images/presentation/attendance-icon.png';
import CONTINUED_ENGAGEMENT from '@/assets/images/presentation/continued-engagement-icon.png';
import HAND_ROI_ICON from '@/assets/images/presentation/hand-return-icon.png';
import VIDEO_STACKS from '@/assets/images/presentation/video-stacks-icon.png';

import { WhyReasons } from '@/components/ui/features/presentation/PresentationReviews/components/WhyReasons';
import { RedCardWithDownloadButton } from '@/components/ui/shared/cards/RedCardWithDownloadButton/RedCardWithDownloadButton';

export const DetailsSection = () => {
  const { t } = useTranslation();

  return (
    <Container textAlign="center" pb={20}>
      <Flex maxW="1000px" flexDirection="column" margin="auto">
        <Flex flexDirection="column" alignItems="center" margin="auto">
          <Text fontFamily="heading" fontSize="3xl">
            {t('virtualEventsPage.detailsHeading.0')}
            <Text as="span" lineHeight={1} fontSize="3xl" fontFamily="heading" fontWeight="bold" color="violet.500">
              {t('virtualEventsPage.detailsHeading.1')}
            </Text>
          </Text>
          <Text mt={6}>{t('virtualEventsPage.detailsDescription')}</Text>
        </Flex>
        <Flex mt={12} gap={8} flexWrap="wrap" justifyContent="center">
          <WhyReasons
            w="312px"
            src={ATOM_ICON}
            alt={t('virtualEventsPage.keyFeatures.0.title')}
            title={t('virtualEventsPage.keyFeatures.0.title')}
            description={t('virtualEventsPage.keyFeatures.0.description')}
          />
          <WhyReasons
            w="312px"
            src={HAND_ROI_ICON}
            alt={t('virtualEventsPage.keyFeatures.1.title')}
            title={t('virtualEventsPage.keyFeatures.1.title')}
            description={t('virtualEventsPage.keyFeatures.1.description')}
          />
          <WhyReasons
            w="312px"
            src={CONTINUED_ENGAGEMENT}
            alt={t('virtualEventsPage.keyFeatures.2.title')}
            title={t('virtualEventsPage.keyFeatures.2.title')}
            description={t('virtualEventsPage.keyFeatures.2.description')}
          />
          <WhyReasons
            w="312px"
            src={VIDEO_STACKS}
            alt={t('virtualEventsPage.keyFeatures.3.title')}
            title={t('virtualEventsPage.keyFeatures.3.title')}
            description={t('virtualEventsPage.keyFeatures.3.description')}
          />
          <WhyReasons
            w="312px"
            src={ATTENDANCE_ICON}
            alt={t('virtualEventsPage.keyFeatures.4.title')}
            title={t('virtualEventsPage.keyFeatures.4.title')}
            description={t('virtualEventsPage.keyFeatures.4.description')}
          />
        </Flex>
      </Flex>
      <RedCardWithDownloadButton
        slug="virtual-events-guide"
        mt={16}
        maxW="1000px"
        mx="auto"
        smallHeading={t('virtualEventsPage.redCardSubheading')}
        heading={t('virtualEventsPage.redCardHeading')}
      />
    </Container>
  );
};
